/********/
var buckle = function(element, options) {
  var that;

  var
    $container,
    $element = $(element),
    $toggles,
    requestData = {
      'legacyMode': 'false'
    },
    loading = false,
    loaded = false,
    settings = {},
    DEFAULT_SETTINGS = {
      'activeClass': 'js-buckle--loading',
      'containerSelector': '.js-buckle-container',
      'disabledClass': 'disabled',
      'paginationDataKey': 'paramPage',
      'onload': false,
      'reload': true,
      'triggerSelector': '.js-buckle-toggle'
    }
  ;

  var init = function(element, options)
  {
    settings = $.extend(DEFAULT_SETTINGS, $element.data(), options);

    $container    = $element.find(settings.containerSelector);
    requestData   = resolveRequestData($element);
    $toggles      = $element.find(settings.triggerSelector);

    // Register handlers.
    $toggles.each(function(i, e) {
      var $e = $(e);

      if ($e.is('select')) {
        $e.on('propertychange change', function(event) {
          event.preventDefault();

          onChangeHandler($e, event);
        });
      } else {
        $e.on('click', function(event) {
          event.preventDefault();

          onClickHandler($e, event)
        });
      }
    });

    $element.trigger(buildEvent('init'));
  };

  var onChangeHandler = function($toggle, event)
  {
    if (isLoading() || $toggle.is('[disabled],.disabled')) {

      return;
    }

    var
      paramName = $toggle.data('name'),
      patchRequestData = {},
      reset = $toggle.data('reset')
    ;

    // Shorthand {var: value} is not possible if key is a variable.
    patchRequestData[paramName] = $toggle.val();

    fetch(patchRequestData, reset);
  }

  var onClickHandler = function($toggle, event)
  {
    if (isLoading() || $toggle.is('[disabled],.disabled')) {

      return;
    }

    var
      patchRequestData = resolveRequestData($toggle),
      reset = $toggle.data('reset')
    ;

    // Fetch the new information.
    fetch(patchRequestData, reset);
  }

  var resolveRequestData = function($e)
  {
    var discoveredData = {};

    // Process parameters to send through ajax data.
    var originalData = $e.data();
    _.each(originalData, function(requestValue, requestKey) {
      if (0 === requestKey.indexOf('param')) {
        // Convert 'paramDataType' -> 'dataType', etc.
        var newKey = requestKey.slice(5).charAt(0).toLowerCase() + requestKey.slice(6);
        discoveredData[newKey] = requestValue;
      }
    });

    return discoveredData;
  }

  var fetch = function(patchRequestData, reset)
  {
    if (isLoaded() && false === settings.reload) {

      return;
    }

    if (undefined === reset) {
      reset = true;
    }

    // Compute this request data.
    requestData = $.extend(requestData, patchRequestData);
    if (reset) {
      // If reset === true, we reset the pagination for this request.
      requestData['page'] = 1;
    }

    $.ajax({
      context: that,
      type: 'GET',
      data: requestData,
      url: settings.url,
      'beforeSend': function(jqXHR, ajaxSettings) {
        // Start the loading state.
        loading = true;
        $element.addClass(settings.activeClass);

        // Trigger some event.
        $element.trigger(buildEvent('ajaxSend'));
        $element.trigger(buildEvent('send', {'requestData': requestData}));

        disableAllToggles();
      },
      'error': function(jqXHR, textStatus, errorThrown) {
        $element.trigger(buildEvent('ajaxError'));
        $element.trigger(buildEvent('error', {'errorString': errorThrown}));
      },
      'success': function(data, textStatus, jqXHR) {
        // Fill the $container element with the back-end rendered html.
        if (reset) {
          $container.html(data.html);
        } else {
          $container.append(data.html);
        }

        enableAllToggles();

        // Set the next pagination.
        setCurrentPage(requestData['page'] + 1);

        if (!reset && !data.hasMore) {
          disableAllToggles(function(e) {
            return undefined !== $(e).data(settings.paginationDataKey);
          });
        }

        // Trigger some event.
        $element.trigger(buildEvent('ajaxSuccess'));
        $element.trigger(buildEvent('success', {'responseData': data}));
      },
      'complete': function(jqXHR, textStatus) {
        loading = false;
        $element.removeClass(settings.activeClass);
        loaded = true;

        // Trigger some event.
        $element.trigger(buildEvent('ajaxComplete'));
        $element.trigger(buildEvent('done'));
      }
    });
  };

  var enableAllToggles = function()
  {
    $toggles
      .removeClass(settings.disabledClass)
      .filter('input, select')
      .removeAttr('disabled')
    ;
  }

  var disableAllToggles = function(filterCallback)
  {
    if (!filterCallback) {
      filterCallback = function(e) {
        return true;
      };
    }

    $toggles.each(function(i, e) {
      var $e = $(e);

      if (filterCallback(e)) {
        $e
          .addClass(settings.disabledClass)
          .filter('input, select')
          .attr('disabled', true)
        ;
      }
    });
  }

  var setCurrentPage = function(currentPage)
  {
    $toggles.each(function(i, e) {
      var $e = $(e);

      if ('undefined' !== typeof $e.data(settings.paginationDataKey)) {
        $e.data(settings.paginationDataKey, currentPage);
      }
    });
  }

  var getContainer = function()
  {
    return $container;
  }

  var getElement = function()
  {
    return $element;
  }

  var getRequestData = function()
  {
    return requestData;
  }

  var getToggles = function()
  {
    return $toggles;
  }

  var isLoading = function()
  {
    return loading;
  }

  var isLoaded = function()
  {
    return loaded;
  }

  var buildEvent = function(name, extraData)
  {
    return $.Event(name + '.jq.buckle', $.extend({
      'buckle': that
    }, extraData));
  }

  init(element, options);
  that = {
    'fetch': fetch,
    'getContainer': getContainer,
    'getElement': getElement,
    'getRequestData': getRequestData,
    'getToggles': getToggles,
    'isLoaded': isLoaded,
    'isLoading': isLoading
  };

  if (settings.onload) {
    // Fetch all the things onload.
    fetch();
  }

  return that;
};

$.fn.buckle = function(options) {
  return this.each(function() {
    if (undefined == $(this).data('buckle')) {
      var plugin = new buckle(this, options);
      $(this).data('buckle', plugin);
    }
  });
}

$(document).ready(function() {
  $('[data-toggle="buckle"]').buckle();
});
